<template>
  <div class="shape" :style="[shapeStyle, stateColor]">
    <slot />
  </div>
</template>

<script>
export default {
  name: "DuctEntryShape",

  props: {
    shape: {
      type: String,
      required: true
    },
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number | null,
      required: this.shape === "rectangle"
    },
    state: {
      type: Number,
      default: 1
    }
  },

  computed: {
    gridUnitSize() {
      return this.$store.getters.getMaskGridUnitSize;
    },

    shapeStyle() {
      switch (this.shape) {
        case "circle":
          return this.getCircleShape();
        case "square":
          return this.getEvenSizedShape();
        case "rectangle":
          return this.getOddSizedShape();
        default:
      }
    },

    stateColor() {
      let color;
      switch (this.state) {
        //Totally reserved
        case 0:
          color = "#3366FF";
          break;
        //Free
        case 1:
          color = "white";
          break;
        //Occupied
        case 2:
          color = "#FFCC99";
          break;
        //Unusable
        case 3:
          color = "#FF0000";
          break;
        //Without state
        default:
          color = "white";
      }

      return {
        backgroundColor: color
      };
    }
  },

  methods: {
    getCircleShape() {
      let circleShape = this.getEvenSizedShape();
      circleShape.borderRadius = "100%";
      return circleShape;
    },

    getEvenSizedShape() {
      let localSize = this.getLocalSize(this.width);
      return {
        width: localSize,
        height: localSize
      };
    },
    getOddSizedShape() {
      return {
        width: this.getLocalSize(this.width),
        height: this.getLocalSize(this.height)
      };
    },

    getLocalSize(size) {
      return size * this.gridUnitSize - 2 + "px";
      //The -4 removes the space occupied by the shape' border
    }
  }
};
</script>

<style scoped>
.shape {
  border: 2px solid black;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Masks/Duct/DuctEntryShape.vue